import { createSelector } from 'reselect';

/**
 * Direct selector to the account state domain
 */

const selectAccountDomain = state => state.account;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Account
 */

const makeSelectAccount = () =>
  createSelector(
    selectAccountDomain,
    substate => substate,
  );
const makeSelectProcessing = () =>
  createSelector(
    selectAccountDomain,
    substate => substate.processing,
  );
const makeSelectUpdateAccountResult = () =>
  createSelector(
    selectAccountDomain,
    substate => substate.updateAccountResult,
  );
const makeSelectChangePasswordResult = () =>
  createSelector(
    selectAccountDomain,
    substate => substate.changePasswordResult,
  );
const makeSelectContentfulToolsResult = () =>
  createSelector(
    selectAccountDomain,
    substate => substate.contentfulToolsResult,
  );
const makeSelectDetailedUserHistory = () =>
  createSelector(
    selectAccountDomain,
    substate => substate.userHistory,
  );

export {
  selectAccountDomain,
  makeSelectAccount,
  makeSelectProcessing,
  makeSelectUpdateAccountResult,
  makeSelectChangePasswordResult,
  makeSelectContentfulToolsResult,
  makeSelectDetailedUserHistory,
};
